/* src/app/notification-settings/delivery-type-modal/delivery-type-modal.component.scss */
.modal-header {
  border-bottom: none;
  padding: 22px 30px 16px 60px;
}
.modal-header h4 {
  font-size: 32px;
}
.modal-sub-header {
  padding: 0 60px 16px;
}
.modal-body {
  display: flex;
  flex-flow: column;
  row-gap: 1.5rem;
  padding: 0 60px;
}
.modal-body .labeled-input {
  display: flex;
  flex-flow: column;
  padding-bottom: 16px;
}
.modal-body .labeled-input label {
  font-size: 14px;
  font-weight: 700;
  padding-bottom: 5px;
}
.modal-body .labeled-input label:has(~ .error-message) {
  color: #C91913;
}
.modal-body .labeled-input .email-input {
  width: 310px;
  padding-right: 2rem;
}
.modal-body .labeled-input .ups-icon-x-circle {
  color: #DF2901;
  font-size: 24px;
}
.modal-body .labeled-input .error-icon::after {
  font-family: "upsicons", fantasy !important;
  content: "\e638" !important;
  color: #C91913;
  position: absolute;
  font-size: 16px;
  right: 4.5rem;
  bottom: 0.3rem;
}
.modal-footer {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  border-top: none;
  padding: 32px 60px;
}
.btn-green {
  color: white;
  background-color: #00857D;
  border-radius: 35px;
  width: 120px;
  height: 36px;
}
.error-message {
  margin-top: 0.5rem;
  color: #C91913;
}
.add-email-btn {
  color: #426DA9;
  font-size: 16px;
  display: flex;
  column-gap: 8px;
  align-items: center;
}
.add-email-btn .ups-icon {
  font-size: 24px;
}
/*# sourceMappingURL=delivery-type-modal.component.css.map */
